import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import { PlanInterval, Subscription, SubscriptionSource, TRIAL_SECONDARY_SOURCE, Feature } from '../../../models';
import { BillingCycle } from './BillingCycle';
import RenewalStatus from './RenewalStatus';
import { useNavigate, useQuery } from '../../../routes';
import { checkout } from '../../../layout/routes';

const useStyles = makeStyles(theme => ({
  boxContainer: {
    [theme.breakpoints.up('dsm')]: {
      height: theme.spacing(8),
    },
  },
  upgradeButton: {
    backgroundColor: '#5959EB',
    color: '#fff',
    height: theme.spacing(3.5),
    '&:hover': {
      backgroundColor: '#43509B',
    },
  },
}));

export const SubscriptionQuota = (
  { subscription }: {
    subscription: Subscription,
  },
) => {
  const classes = useStyles();
  const { navigate, replaceQuery } = useNavigate();
  const { queryDictionary } = useQuery();

  const handleUpgrade = () => {
    const feature = Feature.fromString(subscription.feature.toUpperCase());
    if (!feature) return;

    const prefix = Feature.getFeaturePrefix(feature);
    navigate(
      checkout.path,
      replaceQuery({
        ...queryDictionary(),
        [`${prefix}Quota`]: subscription.quota,
        [`${prefix}Cycle`]: PlanInterval.YEAR,
      }),
    );
  };

  return (
    <>
      {!TRIAL_SECONDARY_SOURCE.includes(subscription.secondarySource) && (
        <Box
          display="flex"
          flexDirection="row"
          alignContent="center"
          alignItems="center"
          paddingTop={1}
          className={classes.boxContainer}
          gap={1}
        >
          <BillingCycle
            source={subscription.source}
            billingInterval={subscription.billingInterval}
          />
          {subscription.billingInterval === PlanInterval.MONTH
            && subscription.source === SubscriptionSource.RECURLY && (
            <Button
              variant="contained"
              size="small"
              onClick={handleUpgrade}
              className={classes.upgradeButton}
            >
              <FormattedMessage id="page.subscription.upgrade" />
            </Button>
          )}
        </Box>
      )}
      <Box
        display="flex"
        flexDirection="column"
        paddingTop={1}
        className={classes.boxContainer}
      >
        <RenewalStatus
          productName={subscription.feature.toLowerCase()}
          source={subscription.source}
          secondarySource={subscription.secondarySource}
          canceledAt={subscription.canceledAt}
          expiryDate={subscription.expiryDate}
          recurlySubscriptionId={subscription.recurlySubscriptionId}
          autoRenewalEnabled={subscription.autoRenewEnabled ?? false}
        />
      </Box>
    </>
  );
};
